// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"d7de4cef","285":"a0440b90","458":"9150a294","631":"2163568a","774":"6b769b67","787":"acb79df8","851":"72701bd0","858":"f2ff94e2"}[chunkId] + ".chunk.js";
};